import React, { ReactNode, useEffect, useState } from 'react'

import { useDashboardFolders } from 'redux/hooks/DashboardFolders'

import Button from 'components_new/atoms/Button'
import MenuItem from 'components_new/atoms/Menu/MenuItem'
import TextField from 'components_new/atoms/TextField'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

interface MoveDialogProps {
  folderId: string | null
  onClose: () => void
  onSubmit: (folderId: string | null) => void
  open: boolean
  title?: ReactNode | string
}

const MoveDialog = (props: MoveDialogProps) => {
  const { folderId, onClose, onSubmit, open, title = '' } = props

  const folders = useDashboardFolders()

  const [newFolderId, setNewFolderId] = useState<string | null>(null)

  useEffect(() => {
    setNewFolderId(folderId)
  }, [folderId])

  return (
    <SimpleDialog
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            Avbryt
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              onSubmit(newFolderId)
              onClose()
            }}
          >
            Flytta
          </Button>
        </>
      }
      contentText={
        <>
          Välj vilken mapp som du vill flytta <code>{title}</code> till.
        </>
      }
      onClose={onClose}
      open={open}
      title={'Flytta dashboard?'}
    >
      <TextField
        fullWidth={true}
        label="Välj mapp..."
        select={true}
        autoComplete="off"
        value={newFolderId || null}
        onChange={(event) => setNewFolderId(event.target.value)}
      >
        <MenuItem value={null}>
          <em>Ingen</em>
        </MenuItem>
        {folders.map((folder) => {
          return (
            <MenuItem key={folder.id} value={folder.id}>
              {folder.name}
            </MenuItem>
          )
        })}
      </TextField>
    </SimpleDialog>
  )
}

export default MoveDialog
